module.exports = __webpack_public_path__ + "img/nickname-active-logo.a74ae522.png";